import { frappeList } from "./utils";
import type { Bin, Warehouse } from "./types/stock";

export const stock = {
  /**
   * Get stock levels for an item
   */
  perItem(itemCode: string): Promise<Bin[]> {
    return frappeList<Bin>("Bin", { item_code: itemCode }, [
      "name",
      "item_code",
      "warehouse",
      "actual_qty",
      "reserved_qty",
      "projected_qty",
    ]);
  },

  /**
   * Get stock levels for a warehouse
   */
  perWarehouse(warehouse: string): Promise<Bin[]> {
    return frappeList<Bin>("Bin", { warehouse }, [
      "name",
      "item_code",
      "warehouse",
      "actual_qty",
      "reserved_qty",
      "projected_qty",
    ]);
  },

  /**
   * Get all warehouses
   */
  warehouses(): Promise<Warehouse[]> {
    return frappeList<Warehouse>("Warehouse", undefined, [
      "name",
      "warehouse_name",
      "company",
      "disabled",
    ]);
  },
};

